var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",class:{
  'foregroundNetwork': this.type==='foreground',
  'backgroundNetwork': this.type==='background',
  'globeNetwork': this.type==='globe'
        }})}
var staticRenderFns = []

export { render, staticRenderFns }